import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { buttonStyles } from '@/lib/button'

interface PaginationProps {
    page: number
    totalPages: number
    basePath: string
}

const pageHref = (basePath: string, page: number): string => (page <= 1 ? basePath : `${basePath}?page=${page}`)

export const Pagination: FC<PaginationProps> = ({ page, totalPages, basePath }): ReactNode => {
    if (totalPages <= 1) return null

    return (
        <nav aria-label='Pagination' className='mt-16 flex items-center justify-between gap-4 border-t border-border pt-8'>
            <div className='flex-1'>
                {page > 1 && (
                    <Link href={pageHref(basePath, page - 1)} rel='prev' className={buttonStyles('outline')}>
                        <ArrowLeft className='size-4' aria-hidden='true' />
                        Newer
                    </Link>
                )}
            </div>

            <p className='text-sm text-muted-foreground tabular-nums'>
                Page {page} of {totalPages}
            </p>

            <div className='flex flex-1 justify-end'>
                {page < totalPages && (
                    <Link href={pageHref(basePath, page + 1)} rel='next' className={buttonStyles('outline')}>
                        Older
                        <ArrowRight className='size-4' aria-hidden='true' />
                    </Link>
                )}
            </div>
        </nav>
    )
}
